import * as React from 'react';
import { Text, View, TouchableOpacity, Image, StyleSheet, Linking} from 'react-native';
import { Colors, Fonts } from '../utils/Constants';
import ReactGA from 'react-ga';

export default class Header extends React.PureComponent{
  constructor(props){
    super(props);
    this.state={
      showMenu: false
    }
  }

  createCampaign = () => {
    ReactGA.event({
      category: 'User',
      action: 'Create Campaign Request'
    });
    Linking.openURL('https://forms.gle/zEi3fG4j7Wo6qmQdA');
  }
  render(){
    let hamburgerCutoff = 570;
    let width = this.props.width ? this.props.width : '90%';
    let screenWidth = this.props.screenWidth ? this.props.screenWidth : '90%';
    let tintColor = this.props.color ? this.props.color : 'white';
    return (
      <View style={{width: width}}>
        <View style={[styles.header, {width: '100%'}]}>
          <TouchableOpacity onPress={()=> this.props.navigation.navigate('Landing')}>
            <Image source={require('../assets/images/dyp_logo.svg')} style={[styles.image, {tintColor: tintColor}]}/>
          </TouchableOpacity>
          {(screenWidth === '90%' || screenWidth >=hamburgerCutoff) &&
          <View style={styles.rightSection}>
            <TouchableOpacity style={styles.buttons} onPress={()=> this.props.navigation.navigate('Browse')}>
              <Text style={[styles.text, {color: tintColor}]}>Browse Campaigns</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.buttons} onPress={this.createCampaign}>
              <Text style={[styles.text, {color: tintColor}]}>Create a Campaign</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.buttons} onPress={()=> this.props.navigation.navigate('About')}>
              <Text style={[styles.text, {color: tintColor}]}>About</Text>
            </TouchableOpacity>
            {/* <Button text={'Sign Up'} textColor={'white'} color={'#33789B'} height={40} width={88} border={20}/> */}
          </View>
          }
          {(!(screenWidth === '90%' || screenWidth >=hamburgerCutoff) && !this.state.showMenu) &&
            <TouchableOpacity onPress={()=> this.setState({showMenu: !this.state.showMenu})}>
              <Image source={require('../assets/images/menu.svg')} style={[styles.menuImage, {tintColor: tintColor}]}/>
            </TouchableOpacity>
          }
          {(!(screenWidth === '90%' || screenWidth >=hamburgerCutoff) && this.state.showMenu) &&
            <TouchableOpacity onPress={()=> this.setState({showMenu: !this.state.showMenu})}>
              <Image source={require('../assets/images/exit.svg')} style={[styles.menuImage, {tintColor: tintColor}]}/>
            </TouchableOpacity>
          }
        </View>
        {(!(screenWidth === '90%' || screenWidth >=hamburgerCutoff) && this.state.showMenu) &&
        <View style={styles.menuSection}>
          <TouchableOpacity style={{margin: 10}} onPress={()=> this.props.navigation.navigate('Browse')}>
            <Text style={[styles.menuText, {color: tintColor}]}>Browse Campaigns</Text>
          </TouchableOpacity>
          <TouchableOpacity style={{margin: 10}} onPress={this.createCampaign}>
            <Text style={[styles.menuText, {color: tintColor}]}>Create a Campaign</Text>
          </TouchableOpacity>
          <TouchableOpacity style={{marginTop: 10, marginBottom: 20}} onPress={()=> this.props.navigation.navigate('About')}>
            <Text style={[styles.menuText, {color: tintColor}]}>About</Text>
          </TouchableOpacity>
          {/* <Button text={'Sign Up'} textColor={'white'} color={'#33789B'} height={40} width={88} border={20}/> */}
        </View>
        }
      </View>
    )
  }
}

const styles = StyleSheet.create({
  header:{
    flexDirection: 'row',
    alignItems: 'center',
    height: 60,
    justifyContent: 'space-between',
    backgroundColor: 'transparent'
  },
  image: {
    width: 40,
    height: 40,
    resizeMode: 'contain'
  },
  menuImage: {
    width: 30,
    height: 30,
    resizeMode: 'contain',
  },
  text: {
    fontFamily: Fonts.mainFont,
    textAlign: 'center',
    color: 'white'
  },
  buttons: {
    paddingRight: 40,
  },
  menuText: {
    fontFamily: Fonts.mainFont,
    textAlign: 'center',
    color: 'white'
  },
  rightSection: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  menuSection: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }
});